import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './fonts/style.css'
import App from './App'
import * as serviceworkerregistration from './serviceWorkerRegistration'
import { AppProvider } from './context'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <AppProvider>
    <App />
  </AppProvider>
)
// تسجيل service worker
serviceworkerregistration.register({
  onUpdate: registration => {
    const waitingServiceWorker = registration.waiting;
    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", event => {
        if (event.target.state === "activated") {
          window.location.reload();
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  }
});

export default root
